/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import cx from 'classnames';

import Banner from './Banner';
import MobileNavigation from './MobileNavigation';
import Navigation from './Navigation';
import PlpContext from '../../templates/Plp/context';
import constants from '../../utils/constants';
import styles from './styles.module.scss';

const Header = () => {
  const {
    sites: { us },
  } = constants;

  const signUpUrl = channel => {
    let url = `/Account/SignUp`;
    let newChannel = channel;

    if (channel.indexOf('/app') === 0) {
      newChannel = channel.substring(4);
    }
    if (newChannel && newChannel.length > 0) {
      url += `?returnUrl=${encodeURIComponent(newChannel)}`;
    }
    return url;
  };

  return (
    <PlpContext.Consumer>
      {({
        plp: { channelurl = '', coBrandedLogo = null } = {},
        hideAppLinks = false,
      } = {}) => {
        return (
          <header className="has-scrolled" id="header">
            <Banner />
            <div className="container">
              <div
                className={cx('logo', { [styles.logoContainer]: hideAppLinks })}
              >
                <a
                  className={cx({ [styles.logo]: hideAppLinks })}
                  href={`https://${us}`}
                >
                  Kabbage
                </a>
              </div>
              {coBrandedLogo && (
                <div className="partner-logo-container">
                  <img src={coBrandedLogo.sourceUrl} />
                </div>
              )}
              {!hideAppLinks && (
                <>
                  <MobileNavigation signUpUrl={signUpUrl(channelurl)} />
                  <Navigation signUpUrl={signUpUrl(channelurl)} />
                </>
              )}
            </div>
          </header>
        );
      }}
    </PlpContext.Consumer>
  );
};

export default Header;
